import React, { useEffect, useState } from "react";
import ImagePreview from "./ImagePreview";
// import CustomIconButton from "./Icon";

import Modal from "react-modal";
Modal.setAppElement("#root");

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    zIndex: 200,
  },
};

function Modals({ modalIsOpen, openModal, closeModal, url, modalData }) {
  const extension = modalData?.split(".").pop().toLowerCase();

  return (
    <div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
        size="lg"
        centered
      >
        <div>
          <div className="flex justify-end ">
            {/* <CustomIconButton
              iconName="Close"
              color="white"
              ariaLabel="close"
              onClick={closeModal}
            /> */}
          </div>


          <ImagePreview
            dataUri={modalData}
            fileType={extension}
            className="w-full min-w-full max-w-full h-full"
          />

          {/* <PDFViewerComponent url={modalData} /> */}
        </div>
      </Modal>
    </div>
  );
}

export default Modals;  